import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import store from '../../store';
import {text} from '../../../../common/tpl/directives';
import seluxLogo from '../../../icons/selux-logo';

@customElement('specsheet-footer')
export class SpecsheetFooter extends connect(store)(LitElement) {

	static styles = css`
		.footer {
			bottom: 0px;
			position: absolute;
			margin-left: 80px;
		}

		.footer p {
			font: var(--font-specsheet-print-small-light);
		}

		.address {
			font: var(--font-specsheet-print-small-bold);
		}

		.date {
			font: var(--font-specsheet-print-small-light);

		}
		.price {
			font: var(--font-specsheet-print-small-light);
		}
		@media print {
		.footer {
			margin-left: 0;
		}
	}
	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.featuremodel = state.featureModel;
		this.productData = state.productData;
		this.status = state.status;
		this.price = state.price.data.totalPriceInEuro;
	}

	currentDate() {
		const now = new Date();
		return (now.getDate()) + '.' + (now.getMonth() + 1) + '.' + now.getFullYear();
	}
	render() {
		const s = this.state;
		return html`
		<div class="footer">
			<p>
				<trans-label key="TE_Footer" context="D.L"></trans-label>
				<span class="date">${this.currentDate()}</span>
				<span class="price">${this.price}</span>
				<br>
				<span class="address">Selux GmbH, Volkmarstraße 18, D-12099 Berlin, T +49 30 72001-0, F -100, info@selux.de, www.selux.com</span>
			</p>
		</div>
		`;
	}
}
